import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getPatentOptions } from '@/module/Author/Patent';
import { PatentEdit } from '@/module/Author/Patent/PatentEdit';

export const Route = createFileRoute('/_auth/author/_author/patent/_patent/$patentId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { patentId } = Route.useParams();
  const { data: patent } = useSuspenseQuery(getPatentOptions(patentId));

  return <PatentEdit patent={patent} />;
}
